/* export const Reglamentos = [
    {
        id: 1,
        href: "docs/LeydeUniversidades1970.pdf",
        titulo: "Ley de Universidades 1970"
    },
    {
        id: 2,
        href: "docs/LeydeServicioComunitario2005.pdf",
        titulo: "Ley de Servicio Comunitario 2005"
    },
    {
        id: 3,
        href: "docs/ReglamentosCursosIntensivosIUDLM.pdf",
        titulo: "Reglamento de Cursos Intensivos IUDLM (Cursos de Verano)"
    },
    {
        id: 4,
        href: "docs/ReglamentodeBecasEstudiantiles.pdf",
        titulo: "Reglamento de Becas Estudiantiles"
    },
    {
        id: 5,
        href: "docs/ReglamentodeExtensiónUniversitaria.pdf",
        titulo: "Reglamento de Extensión Universitaria - Mayo 2019"
    },
    {
        id: 6,
        href: "docs/ReglamentodelTrabajodeGrado.pdf",
        titulo: "Reglamento del Trabajo de Grado IUDLM - Enero 2019"
    },
    {
        id: 7,
        href: "docs/ReglamentodePasantíasProfesionales.pdf",
        titulo: "Reglamento de Pasantías Profesionales - Junio 2019"
    },
    {
        id: 8,
        href: "docs/ReglamentodeReconocimientodeEstudios.pdf",
        titulo: "Reglamento de Reconocimiento de Estudios y Pruebas de Sufuciencia - Junio 2019"
    },
    {
        id: 9,
        href: "docs/ReglamentoDisciplinarioEstudiantil.pdf",
        titulo: "Reglamento Disciplinario Estudiantil"
    },
    {
        id: 10,
        href: "docs/ReglamentoInternoIUDLM.pdf",
        titulo: "Reglamento Interno IUDLM - Junio 2019"
    },
    {
        id: 11,
        href: "docs/ReglamentodelServicioComunitariodelEstudiante.pdf",
        titulo: "Reglamento de Servicio Comunitario del Estudiante IUDLM"
    }
] */

export const Reglamentos = [
    {
        id: 1,
        href: "docs/REGLAMENTO_INTERNO_IUDLM.pdf",
        titulo: "Reglamento Interno"
    },
    {
        id: 2,
        href: "docs/REGLAMENTO_GENERAL_DE_EVALUACION_DEL_DESEMPENO_ESTUDIANTIL_IUDLM.pdf",
        titulo: "Reglamento General de Evaluación del Desempeño Estudiantil IUDLM"
    },
    {
        id: 3,
        href: "docs/REGLAMENTO_DISCIPLINARIO_ESTUDIANTIL_IUDLM.pdf",
        titulo: "Reglamento Disciplinario Estudiantil IUDLM"
    },
    {
        id: 4,
        href: "docs/REGLAMENTO_DE_TRABAJO_DE_GRADO_IUDLM.pdf",
        titulo: "Reglamento de Trabajo de Grado IUDLM"
    },
    {
        id: 5,
        href: "docs/REGLAMENTO_DE_SERVICIO_COMUNITARIO_IUDLM.pdf",
        titulo: "Reglamento de Servicio Comunitario IUDLM"
    },
    {
        id: 6,
        href: "docs/REGLAMENTO_DE_PRUEBAS_DE_SUFICIENCIA_IUDLM.pdf",
        titulo: "Reglamento de Pruebas de Suficiencia IUDLM"
    },
    {
        id: 7,
        href: "docs/REGLAMENTO_DE_PASANTIAS_PROFESIONALES_IUDLM.pdf",
        titulo: "Reglamento de Pasantías Profesionales IUDLM"
    },
    {
        id: 8,
        href: "docs/REGLAMENTO_DE_CURSOS_INTENSIVOS_IUDLM.pdf",
        titulo: "Reglamento de Cursos Intensivos IUDLM"
    },
    {
        id: 9,
        href: "docs/REGLAMENTO_DE_BECAS_ESTUDIANTILES_IUDLM.pdf",
        titulo: "Reglamento de Becas Estudiantiles IUDLM"
    }
]


// WEBPACK FOOTER //
// ./src/shared/Reglamentos.jsx